// import React, { useState, useEffect, useRef } from 'react';
// import { SoccerPitch } from './Pitches/SoccerPitch';
// import { BasketballPitch } from './Pitches/BasketballPitch';
// import { FootballPitch } from './Pitches/FootballPitch';

// // Diccionario de enrutamiento para las vistas de las canchas
// const PITCH_COMPONENTS = {
//     'soccer': SoccerPitch,
//     'basketball': BasketballPitch,
//     'flag_football': FootballPitch
// };

// /**
//  * COMPONENTE VISUAL: LINEUP OVERLAY (ROUTER / VISUAL)
//  * ------------------------------------------------------------------
//  * Maneja la máquina de estados de la presentación "Euphoria" y 
//  * enruta el diseño de la cancha según el deporte activo.
//  * ------------------------------------------------------------------
//  */
// const Lineup = ({ data }) => {
//     // --- ESTADO DE LA ALINEACIÓN ---
//     const [lineup, setLineup] = useState(null); // Evitamos rupturas de renderizado al iniciar en null
//     const [presentation, setPresentation] = useState({ isActive: false, player: null, step: 0 });
//     const [isBoardVisible, setIsBoardVisible] = useState(true);

//     const flashContainerRef = useRef(null);
//     const flashIntervalRef = useRef(null);
//     const sequenceTimeoutsRef = useRef([]);

//     // --- 1. ESCUCHA DE ACTUALIZACIONES (SOCKET) ---
//     useEffect(() => {
//         if (!data || !data.data) return;

//         const { type, data: payload } = data;

//         if (type === 'lineup.state_update') {
//             setLineup(payload);
//         } else if (type === 'lineup.presentation') {
//             handlePresentationCommand(payload);
//         }
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//     }, [data]);

//     // --- 2. MÁQUINA DE ESTADOS: "EUPHORIA" Y VISIBILIDAD ---
//     const handlePresentationCommand = (command) => {
//         const { action, playerId } = command;

//         // Comandos de visibilidad máster de la pizarra
//         if (action === 'show_board') { setIsBoardVisible(true); return; }
//         if (action === 'hide_board') { setIsBoardVisible(false); return; }

//         if (action === 'close') {
//             abortPresentation();
//             return;
//         }

//         if (!lineup) return; // Validación de integridad táctica

//         let targetPlayer = null;
//         if (action === 'show_dt') {
//             // Evaluamos dinámicamente si se presenta como Head Coach o Director Técnico
//             targetPlayer = { 
//                 name: lineup.managerName, 
//                 dorsal: lineup.gameMode === 'basketball' ? 'HC' : 'DT', 
//                 isManager: true 
//             };
//         } else if (action === 'show_player' && playerId !== null) {
//             targetPlayer = lineup.players.find(p => p.playerId === playerId);
//         }

//         if (targetPlayer) {
//             startPresentationSequence(targetPlayer);
//         }
//     };

//     const startPresentationSequence = (player) => {
//         abortPresentation(); 

//         const nameParts = player.name.split(' ');
//         const lastName = nameParts.pop();
//         const firstName = nameParts.join(' ');

//         setPresentation({
//             isActive: true,
//             player: { ...player, firstName, lastName },
//             step: 1 
//         });

//         // Loop de números en ráfaga (Euphoria Core)
//         flashIntervalRef.current = setInterval(() => {
//             createFlashNumber(player.dorsal.toString());
//         }, 180);

//         sequenceTimeoutsRef.current.push(setTimeout(() => {
//             setPresentation(prev => ({ ...prev, step: 2 }));
//         }, 1500));

//         sequenceTimeoutsRef.current.push(setTimeout(() => {
//             setPresentation(prev => ({ ...prev, step: 3 }));
//         }, 3500));

//         sequenceTimeoutsRef.current.push(setTimeout(() => {
//             setPresentation(prev => ({ ...prev, step: 4 }));
//         }, 5500));

//         sequenceTimeoutsRef.current.push(setTimeout(() => {
//             abortPresentation();
//         }, 9500));
//     };

//     const abortPresentation = () => {
//         sequenceTimeoutsRef.current.forEach(clearTimeout);
//         sequenceTimeoutsRef.current = [];
//         if (flashIntervalRef.current) clearInterval(flashIntervalRef.current);
//         if (flashContainerRef.current) flashContainerRef.current.innerHTML = '';
        
//         setPresentation({ isActive: false, player: null, step: 0 });
//     };

//     const createFlashNumber = (numberTxt) => {
//         if (!flashContainerRef.current) return;
//         const el = document.createElement('div');
//         el.className = 'flash-number';
//         el.innerText = numberTxt;
//         el.style.top = `${Math.random() * 100}%`;
//         el.style.left = `${Math.random() * 100}%`;
        
//         const size = Math.random() * 45 + 10;
//         el.style.fontSize = `${size}rem`;
//         el.style.opacity = size > 30 ? '0.15' : '0.4';

//         flashContainerRef.current.appendChild(el);
//         setTimeout(() => el.remove(), 450);
//     };

//     // --- 3. ENRUTADOR DE CANCHAS ---
//     const renderPitch = () => {
//         if (!lineup) return null;
//         const ActivePitch = PITCH_COMPONENTS[lineup.gameMode] || SoccerPitch;
//         return <ActivePitch lineup={lineup} />;
//     };

//     // Cláusula de salvaguarda: si no hay datos de alineación aún, no renderizamos nada para evitar errores
//     if (!lineup) return null;

//     // Rutas dinámicas de activos fotográficos
//     const basePath = "/img/games/lineup/players/";
//     const photoSrc = presentation.player?.isManager 
//         ? `${basePath}${lineup.gameMode === 'basketball' ? 'HC' : 'DT'}.png` 
//         : `${basePath}${presentation.player?.dorsal}.png`;

//     return (
//         <div className={`lineup-wrapper mode-${lineup.gameMode}`} 
//              style={{ 
//                  '--kit-color': lineup.kitColor, 
//                  '--accent-color': '#fbbf24', 
//                  opacity: isBoardVisible ? 1 : 0, 
//                  transition: 'opacity 0.8s ease-in-out' 
//              }}>
            
//             <header className="lineup-header">
//                 <h1>{lineup.teamName}</h1>
//             </header>

//             <main className="lineup-main">
//                 <div className="pitch-container">
//                     {renderPitch()}
//                 </div>
//             </main>

//             {/* OVERLAY DE PRESENTACIÓN "EUPHORIA" */}
//             {presentation.isActive && (
//                 <div className="presentation-overlay active">
//                     <img src="/img/overlays/lineup/logo.png" onError={(e) => e.target.style.display='none'} className="pres-logo" alt="Logo" />
                    
//                     <div className="pres-layer pres-bg-base"></div>
//                     <div className={`pres-layer pres-bg-storm ${presentation.step >= 4 ? 'anim-bg-storm' : ''}`}></div>
                    
//                     <div ref={flashContainerRef} className="pres-random-numbers"></div>

//                     <div className={`pres-container ${presentation.step === 3 ? 'anim-euphoria-shake' : ''}`}>
                        
//                         <div className="pres-showcase-wrapper">
//                             <div className={`pres-photo-container ${presentation.step >= 3 ? 'anim-pro-card-reveal' : ''}`}>
//                                 <img 
//                                     src={photoSrc} 
//                                     className={`pres-photo-img ${presentation.step >= 3 ? 'anim-pro-photo-zoom' : ''} ${presentation.step >= 4 ? 'anim-photo-alive' : ''}`} 
//                                     onError={(e) => {
//                                         e.target.onerror = null; 
//                                         e.target.src = '/img/games/lineup/players/default.png';
//                                     }}
//                                     alt="Player" 
//                                 />
//                                 {presentation.step >= 3 && <div className="pres-flare anim-pro-flare"></div>}
                                
//                                 {presentation.step >= 3 && (
//                                     <div className="pres-card-number">
//                                         {presentation.player?.isManager ? (lineup.gameMode === 'basketball' ? 'HC' : 'DT') : presentation.player?.dorsal}
//                                     </div>
//                                 )}
//                             </div>
//                         </div>

//                         <div className={`pres-text-container ${presentation.step >= 2 ? 'anim-text-breathe' : ''}`}>
//                             <div className={`pres-firstname 
//                                 ${presentation.step === 2 ? 'anim-glitch-slam anim-spread-first' : ''}
//                                 ${presentation.step >= 4 ? 'pres-name-settled anim-electric-sustain' : ''}`}
//                             >
//                                 {presentation.player?.firstName}
//                             </div>
                            
//                             <div className={`pres-lastname 
//                                 ${presentation.step === 3 ? 'anim-glitch-slam anim-spread-last' : ''}
//                                 ${presentation.step >= 4 ? 'pres-name-settled anim-electric-sustain' : ''}`}
//                             >
//                                 {presentation.player?.lastName}
//                             </div>
//                         </div>

//                     </div>
//                 </div>
//             )}
//         </div>
//     );
// };

// export { Lineup };









// import React, { useState, useEffect, useRef } from 'react';
// import { SoccerPitch } from './Pitches/SoccerPitch';
// import { BasketballPitch } from './Pitches/BasketballPitch';
// import { FootballPitch } from './Pitches/FootballPitch';

// const PITCH_COMPONENTS = {
//     'soccer': SoccerPitch,
//     'basketball': BasketballPitch,
//     'flag_football': FootballPitch // <-- Asegúrate de importar FootballPitch
// };

// //const ActivePitch = PITCH_COMPONENTS[lineupData.data.gameMode] || SoccerPitch;

// /**
//  * COMPONENTE VISUAL: LINEUP OVERLAY (CEREBRO / ENRUTADOR)
//  * ------------------------------------------------------------------
//  * Maneja la máquina de estados de la presentación "Euphoria" y 
//  * enruta el diseño de la cancha según el deporte activo.
//  * ------------------------------------------------------------------
//  */
// const Lineup = ({ data }) => {
//     // --- ESTADO DE LA ALINEACIÓN ---
//     // const [lineup, setLineup] = useState({
//     //     teamName: "ALINEACIÓN",
//     //     gameMode: "soccer", // Por defecto
//     //     formation: "4-4-2",
//     //     kitColor: "#1e293b",
//     //     managerName: "Director Técnico",
//     //     leftEndzoneText: "LOCAL",
//     //     rightEndzoneText: "VISITA",
//     //     leftEndzoneLogoUrl: "",
//     //     rightEndzoneLogoUrl: "",
//     //     players: []
//     // });
//     const [lineup, setLineup] = useState(null); // Empezamos en null para saber si ya cargó
//     const [presentation, setPresentation] = useState({ isActive: false, player: null, step: 0 });
//     const [isBoardVisible, setIsBoardVisible] = useState(true);

//     const flashContainerRef = useRef(null);
//     const flashIntervalRef = useRef(null);
//     const sequenceTimeoutsRef = useRef([]);

//     // --- 1. ESCUCHA DE ACTUALIZACIONES (SOCKET) ---
//     useEffect(() => {
//         if (!data || !data.data) return;

//         const { type, data: payload } = data;

//         if (type === 'lineup.state_update') {
//             setLineup(payload);
//         } else if (type === 'lineup.presentation') {
//             handlePresentationCommand(payload);
//         }
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//     }, [data]);

//     // --- 2. MÁQUINA DE ESTADOS: "EUPHORIA" ---
//     const handlePresentationCommand = (command) => {
//         const { action, playerId } = command;

//         if (action === 'show_board') { setIsBoardVisible(true); return; }
//         if (action === 'hide_board') { setIsBoardVisible(false); return; }

//         if (action === 'close') {
//             abortPresentation();
//             return;
//         }

//         if (!lineup) return; // Seguridad

//         let targetPlayer = null;
//         if (action === 'show_dt') {
//             targetPlayer = { name: lineup.managerName, dorsal: lineup.gameMode === 'basketball' ? 'HC' : 'DT', isManager: true };
//         } else if (action === 'show_player' && playerId !== null) {
//             targetPlayer = lineup.players.find(p => p.playerId === playerId);
//         }

//         if (targetPlayer) {
//             startPresentationSequence(targetPlayer);
//         }
//     };

//     // --- 3. MAQUETADO DINÁMICO ---
//     const renderPitch = () => {
//         if (!lineup) return null;
//         const ActivePitch = PITCH_COMPONENTS[lineup.gameMode] || SoccerPitch;
//         return <ActivePitch lineup={lineup} />;
//     };

//     const startPresentationSequence = (player) => {
//         abortPresentation(); 

//         const nameParts = player.name.split(' ');
//         const lastName = nameParts.pop();
//         const firstName = nameParts.join(' ');

//         setPresentation({
//             isActive: true,
//             player: { ...player, firstName, lastName },
//             step: 1 
//         });

//         // Flashbacks numéricos optimizados
//         flashIntervalRef.current = setInterval(() => {
//             createFlashNumber(player.dorsal.toString());
//         }, 180);

//         sequenceTimeoutsRef.current.push(setTimeout(() => {
//             setPresentation(prev => ({ ...prev, step: 2 }));
//         }, 1500));

//         sequenceTimeoutsRef.current.push(setTimeout(() => {
//             setPresentation(prev => ({ ...prev, step: 3 }));
//         }, 3500));

//         sequenceTimeoutsRef.current.push(setTimeout(() => {
//             setPresentation(prev => ({ ...prev, step: 4 }));
//         }, 5500));

//         sequenceTimeoutsRef.current.push(setTimeout(() => {
//             abortPresentation();
//         }, 9500));
//     };

//     const abortPresentation = () => {
//         sequenceTimeoutsRef.current.forEach(clearTimeout);
//         sequenceTimeoutsRef.current = [];
//         if (flashIntervalRef.current) clearInterval(flashIntervalRef.current);
//         if (flashContainerRef.current) flashContainerRef.current.innerHTML = '';
        
//         setPresentation({ isActive: false, player: null, step: 0 });
//     };

//     const createFlashNumber = (numberTxt) => {
//         if (!flashContainerRef.current) return;
//         const el = document.createElement('div');
//         el.className = 'flash-number';
//         el.innerText = numberTxt;
//         el.style.top = `${Math.random() * 100}%`;
//         el.style.left = `${Math.random() * 100}%`;
        
//         const size = Math.random() * 45 + 10;
//         el.style.fontSize = `${size}rem`;
//         el.style.opacity = size > 30 ? '0.15' : '0.4';

//         flashContainerRef.current.appendChild(el);
//         setTimeout(() => el.remove(), 450);
//     };

//     // --- 3. ENRUTADOR DE CANCHAS ---
//     // const renderPitch = () => {
//     //     switch (lineup.gameMode) {
//     //         case 'basketball':
//     //             return <BasketballPitch lineup={lineup} />;
//     //         case 'flag_football':
//     //             return <FootballPitch lineup={lineup} />;
//     //         case 'soccer':
//     //         default:
//     //             return <SoccerPitch lineup={lineup} />;
//     //     }
//     // };

//     // Rutas de fotos
//     const basePath = "/img/games/lineup/players/";
//     const photoSrc = presentation.player?.photoUrl 
//         ? `${basePath}${presentation.player.photoUrl}` 
//         : `${basePath}default.png`;

//     return (
//         <div className={`lineup-wrapper mode-${lineup.gameMode}`} style={{ '--kit-color': lineup.kitColor, '--accent-color': '#fbbf24', opacity: isBoardVisible ? 1 : 0, transition: 'opacity 0.8s ease-in-out' /* Efecto Fade suave de 0.8s */ }}>    
//         {/* <div className={`lineup-wrapper mode-${lineup.gameMode}`} style={{ '--kit-color': lineup.kitColor, '--accent-color': '#fbbf24'}}>     */}
//             <header className="lineup-header">
//                 <h1>{lineup.teamName}</h1>
//             </header>

//             {/* RENDERIZADO DINÁMICO DE LA CANCHA */}
//             {renderPitch()}

//             {/* OVERLAY DE PRESENTACIÓN "EUPHORIA" (Reutilizado para todos los deportes) */}
//             {presentation.isActive && (
//                 <div className="presentation-overlay active">
//                     <img src="/img/overlays/lineup/logo.png" onError={(e) => e.target.style.display='none'} className="pres-logo" alt="Logo" />
                    
//                     <div className="pres-layer pres-bg-base"></div>
//                     <div className={`pres-layer pres-bg-storm ${presentation.step >= 4 ? 'anim-bg-storm' : ''}`}></div>
                    
//                     <div ref={flashContainerRef} className="pres-random-numbers"></div>

//                     <div className={`pres-container ${presentation.step === 3 ? 'anim-euphoria-shake' : ''}`}>
                        
//                         <div className="pres-showcase-wrapper">
//                             <div className={`pres-photo-container ${presentation.step >= 3 ? 'anim-pro-card-reveal' : ''}`}>
//                                 <img 
//                                     src={photoSrc} 
//                                     className={`pres-photo-img ${presentation.step >= 3 ? 'anim-pro-photo-zoom' : ''} ${presentation.step >= 4 ? 'anim-photo-alive' : ''}`} 
//                                     onError={(e) => {
//                                         e.target.onerror = null; 
//                                         e.target.src = `${basePath}default.png`;
//                                     }}
//                                     alt="Player" 
//                                 />
//                                 {presentation.step >= 3 && <div className="pres-flare anim-pro-flare"></div>}
                                
//                                 {presentation.step >= 3 && (
//                                     <div className="pres-card-number">
//                                         {presentation.player?.isManager ? (lineup.gameMode === 'basketball' ? 'HC' : 'DT') : presentation.player?.dorsal}
//                                     </div>
//                                 )}
//                             </div>
//                         </div>

//                         <div className={`pres-text-container ${presentation.step >= 2 ? 'anim-text-breathe' : ''}`}>
//                             <div className={`pres-firstname 
//                                 ${presentation.step === 2 ? 'anim-glitch-slam anim-spread-first' : ''}
//                                 ${presentation.step >= 4 ? 'pres-name-settled anim-electric-sustain' : ''}`}
//                             >
//                                 {presentation.player?.firstName}
//                             </div>
                            
//                             <div className={`pres-lastname 
//                                 ${presentation.step === 3 ? 'anim-glitch-slam anim-spread-last' : ''}
//                                 ${presentation.step >= 4 ? 'pres-name-settled anim-electric-sustain' : ''}`}
//                             >
//                                 {presentation.player?.lastName}
//                             </div>
//                         </div>

//                     </div>
//                 </div>
//             )}
//         </div>
//     );
// };

// export { Lineup };









// Funcional
import React, { useState, useEffect, useRef } from 'react';
import { SoccerPitch } from './Pitches/SoccerPitch';
import { BasketballPitch } from './Pitches/BasketballPitch';
import { FootballPitch } from './Pitches/FootballPitch';

const PITCH_COMPONENTS = {
    'soccer': SoccerPitch,
    'soccer_7': SoccerPitch,
    'basketball': BasketballPitch,
    'flag_football': FootballPitch
};

/**
 * COMPONENTE VISUAL: LINEUP OVERLAY (HIJO) - EDICIÓN OPTIMIZADA
 * ------------------------------------------------------------------
 * Renderiza la cancha en 3D y la secuencia "Euphoria" sin lag.
 * ------------------------------------------------------------------
 */
const Lineup = ({ data }) => {
    // --- ESTADO DE LA ALINEACIÓN ---
    const [lineup, setLineup] = useState({
        teamName: "ALINEACIÓN",
        formation: "4-4-2",
        kitColor: "#1e293b",
        managerName: "Director Técnico",
        players: []
    });

    // --- ESTADOS DE LA PRESENTACIÓN ---
    const [presentation, setPresentation] = useState({
        isActive: false,
        player: null,
        step: 0 
    });

    const flashContainerRef = useRef(null);
    const flashIntervalRef = useRef(null);
    const sequenceTimeoutsRef = useRef([]);

    // -------------------------------------------------------------------------
    // 1. ESCUCHA DE ACTUALIZACIONES (SOCKET) - CORREGIDO
    // -------------------------------------------------------------------------
    useEffect(() => {
        if (!data || !data.data) return;

        const { type, data: payload } = data;

        if (type === 'lineup.state_update') {
            // CORRECCIÓN: Reemplazamos el estado por completo, eliminando duplicados
            setLineup(payload);
        } else if (type === 'lineup.presentation') {
            handlePresentationCommand(payload);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data]);

    const handlePresentationCommand = (command) => {
        const { action, playerId } = command;

        if (action === 'close') {
            abortPresentation();
            return;
        }

        let targetPlayer = null;
        if (action === 'show_dt') {
            let managerName = lineup.managerName || 'Director Técnico';
            let managerPhotoUrl = null;
            if (managerName.includes('|')) {
                const parts = managerName.split('|');
                managerName = parts[0];
                managerPhotoUrl = parts[1];
            }
            targetPlayer = { name: managerName, dorsal: 'DT', isManager: true, photoUrl: managerPhotoUrl };
        } else if (action === 'show_player' && playerId !== null) {
            targetPlayer = lineup.players.find(p => p.playerId === playerId);
        }

        if (targetPlayer) {
            startPresentationSequence(targetPlayer);
        }
    };

    const startPresentationSequence = (player) => {
        abortPresentation(); 

        const nameParts = player.name.split(' ');
        const lastName = nameParts.pop();
        const firstName = nameParts.join(' ');

        setPresentation({
            isActive: true,
            player: { ...player, firstName, lastName },
            step: 1 
        });

        // Loop de números en ráfaga
        flashIntervalRef.current = setInterval(() => {
            createFlashNumber(player.dorsal.toString());
        }, 180);

        sequenceTimeoutsRef.current.push(setTimeout(() => {
            setPresentation(prev => ({ ...prev, step: 2 }));
        }, 1500));

        sequenceTimeoutsRef.current.push(setTimeout(() => {
            setPresentation(prev => ({ ...prev, step: 3 }));
        }, 3500));

        sequenceTimeoutsRef.current.push(setTimeout(() => {
            setPresentation(prev => ({ ...prev, step: 4 }));
        }, 5500));

        sequenceTimeoutsRef.current.push(setTimeout(() => {
            abortPresentation();
        }, 9500));
    };

    const abortPresentation = () => {
        sequenceTimeoutsRef.current.forEach(clearTimeout);
        sequenceTimeoutsRef.current = [];
        if (flashIntervalRef.current) clearInterval(flashIntervalRef.current);
        if (flashContainerRef.current) flashContainerRef.current.innerHTML = '';
        
        setPresentation({ isActive: false, player: null, step: 0 });
    };

    const createFlashNumber = (numberTxt) => {
        if (!flashContainerRef.current) return;
        const el = document.createElement('div');
        el.className = 'flash-number';
        el.innerText = numberTxt;
        el.style.top = `${Math.random() * 100}%`;
        el.style.left = `${Math.random() * 100}%`;
        
        const size = Math.random() * 45 + 10;
        el.style.fontSize = `${size}rem`;
        el.style.opacity = size > 30 ? '0.15' : '0.4';

        flashContainerRef.current.appendChild(el);
        setTimeout(() => el.remove(), 450);
    };

    const renderPitch = () => {
        if (!lineup) return null;
        const ActivePitch = PITCH_COMPONENTS[lineup.gameMode] || SoccerPitch;
        return <ActivePitch lineup={lineup} />;
    };
    // Resolver foto del jugador (Prioriza la subida por base de datos, cae en dorsal local)
    const getPlayerPhoto = () => {
        const player = presentation.player;
        if (!player) return '/img/games/lineup/players/default.png';

        if (player.photoUrl) {
            // Si es una URL completa
            if (player.photoUrl.startsWith('http') || player.photoUrl.startsWith('data:')) {
                return player.photoUrl;
            }
            // Si es relativa a la API
            const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:50586/api/';
            const apiBase = apiUrl.replace('/api/', '');
            if (player.photoUrl.startsWith('/')) {
                return `${apiBase}${player.photoUrl}`;
            }
            return `${apiBase}/${player.photoUrl}`;
        }

        if (player.isManager) {
            return null;
        }

        return `/img/games/lineup/players/${player.dorsal}.png`;
    };

    const photoSrc = getPlayerPhoto();

    return (
        // <div className="lineup-wrapper" style={{ '--kit-color': lineup.kitColor, '--accent-color': '#fbbf24' }}>
        <div className={`lineup-wrapper mode-${lineup.gameMode}`} style={{ '--kit-color': lineup.kitColor, '--accent-color': '#fbbf24'}}>
            <header className="lineup-header">
                <h1>{lineup.teamName}</h1>
            </header>

            {renderPitch()}

            {/* =========================================================
                CORRECCIÓN RENDIMIENTO: El overlay solo se monta si está activo
            ========================================================= */}
            {presentation.isActive && (
                <div className="presentation-overlay active">
                    <img src="/img/games/lineup/logo.png" onError={(e) => e.target.style.display='none'} className="pres-logo" alt="Logo" />
                    
                    <div className="pres-layer pres-bg-base"></div>
                    <div className={`pres-layer pres-bg-storm ${presentation.step >= 4 ? 'anim-bg-storm' : ''}`}></div>
                    
                    {/* Contenedor controlado por Ref para los números Flashback */}
                    <div ref={flashContainerRef} className="pres-random-numbers"></div>

                    <div className={`pres-container ${presentation.step === 3 ? 'anim-euphoria-shake' : ''}`}>
                        
                        {photoSrc && (
                            <div className="pres-showcase-wrapper">
                                <div className={`pres-photo-container ${presentation.step >= 3 ? 'anim-pro-card-reveal' : ''}`}>
                                    <img 
                                        src={photoSrc} 
                                        className={`pres-photo-img ${presentation.step >= 3 ? 'anim-pro-photo-zoom' : ''} ${presentation.step >= 4 ? 'anim-photo-alive' : ''}`} 
                                        onError={(e) => {
                                            e.target.onerror = null; // Rompe bucle infinito si falla default
                                            e.target.src = '/img/games/lineup/players/default.png';
                                        }}
                                        alt="Player" 
                                    />
                                    {presentation.step >= 3 && <div className="pres-flare anim-pro-flare"></div>}
                                    
                                    {presentation.step >= 3 && (
                                        <div className="pres-card-number">
                                            {presentation.player?.isManager ? 'DT' : presentation.player?.dorsal}
                                        </div>
                                    )}
                                </div>
                            </div>
                        )}

                        <div className={`pres-text-container ${presentation.step >= 2 ? 'anim-text-breathe' : ''}`}>
                            <div className={`pres-firstname 
                                ${presentation.step === 2 ? 'anim-glitch-slam anim-spread-first' : ''}
                                ${presentation.step >= 4 ? 'pres-name-settled anim-electric-sustain' : ''}`}
                            >
                                {presentation.player?.firstName}
                            </div>
                            
                            <div className={`pres-lastname 
                                ${presentation.step === 3 ? 'anim-glitch-slam anim-spread-last' : ''}
                                ${presentation.step >= 4 ? 'pres-name-settled anim-electric-sustain' : ''}`}
                            >
                                {presentation.player?.lastName}
                            </div>
                        </div>

                    </div>
                </div>
            )}
        </div>
    );
};

export { Lineup };









// import React, { useState, useEffect, useRef } from 'react';

// /**
//  * COMPONENTE VISUAL: LINEUP OVERLAY (HIJO)
//  * ------------------------------------------------------------------
//  * Renderiza la cancha en 3D y la secuencia "Euphoria" para presentar 
//  * a los jugadores uno por uno en la transmisión (OBS).
//  * ------------------------------------------------------------------
//  */
// const Lineup = ({ data }) => {
//     // --- ESTADO DE LA ALINEACIÓN ---
//     const [lineup, setLineup] = useState({
//         teamName: "EQUIPO",
//         formation: "4-4-2",
//         kitColor: "#1e293b",
//         managerName: "Director Técnico",
//         players: []
//     });

//     // --- ESTADOS DE LA PRESENTACIÓN ---
//     const [presentation, setPresentation] = useState({
//         isActive: false,
//         player: null,
//         step: 0 // 0: Inactivo, 1: Inicio (Flashbacks), 2: Nombre, 3: Foto/Impacto, 4: Sustain
//     });

//     // Referencias para efectos de alto rendimiento (DOM directo para evitar re-renders masivos)
//     const flashContainerRef = useRef(null);
//     const flashIntervalRef = useRef(null);
//     const sequenceTimeoutsRef = useRef([]);

//     // -------------------------------------------------------------------------
//     // 1. ESCUCHA DE ACTUALIZACIONES (SOCKET)
//     // -------------------------------------------------------------------------
//     useEffect(() => {
//         if (!data || !data.data) return;

//         const { type, data: payload } = data;

//         if (type === 'lineup.state_update') {
//             setLineup(payload);
//         } else if (type === 'lineup.presentation') {
//             handlePresentationCommand(payload);
//         }
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//     }, [data]);

//     // -------------------------------------------------------------------------
//     // 2. CONTROL DE LA SECUENCIA "EUPHORIA"
//     // -------------------------------------------------------------------------
//     const handlePresentationCommand = (command) => {
//         const { action, playerId } = command;

//         if (action === 'close') {
//             abortPresentation();
//             return;
//         }

//         let targetPlayer = null;
//         if (action === 'show_dt') {
//             targetPlayer = { name: lineup.managerName, dorsal: 'DT', isManager: true };
//         } else if (action === 'show_player' && playerId !== null) {
//             targetPlayer = lineup.players.find(p => p.playerId === playerId);
//         }

//         if (targetPlayer) {
//             startPresentationSequence(targetPlayer);
//         }
//     };

//     const startPresentationSequence = (player) => {
//         abortPresentation(); // Limpiar secuencias previas

//         // Separar Nombre y Apellido
//         const nameParts = player.name.split(' ');
//         const lastName = nameParts.pop();
//         const firstName = nameParts.join(' ');

//         setPresentation({
//             isActive: true,
//             player: { ...player, firstName, lastName },
//             step: 1 // Inicia flashes y overlay oscuro
//         });

//         // Generador de Flashbacks (DOM directo)
//         flashIntervalRef.current = setInterval(() => {
//             createFlashNumber(player.dorsal.toString());
//         }, 200);

//         // T=2s: Aparece el Nombre
//         sequenceTimeoutsRef.current.push(setTimeout(() => {
//             setPresentation(prev => ({ ...prev, step: 2 }));
//         }, 2000));

//         // T=4s: Aparece Apellido, Foto, Destello y Shake
//         sequenceTimeoutsRef.current.push(setTimeout(() => {
//             setPresentation(prev => ({ ...prev, step: 3 }));
//         }, 4000));

//         // T=6s: Efecto Sustain Final
//         sequenceTimeoutsRef.current.push(setTimeout(() => {
//             setPresentation(prev => ({ ...prev, step: 4 }));
//         }, 6000));

//         // T=10s: Cierre Automático
//         sequenceTimeoutsRef.current.push(setTimeout(() => {
//             abortPresentation();
//         }, 10000));
//     };

//     const abortPresentation = () => {
//         sequenceTimeoutsRef.current.forEach(clearTimeout);
//         sequenceTimeoutsRef.current = [];
//         if (flashIntervalRef.current) clearInterval(flashIntervalRef.current);
//         if (flashContainerRef.current) flashContainerRef.current.innerHTML = '';
        
//         setPresentation(prev => ({ ...prev, isActive: false, step: 0 }));
//     };

//     // Generador de números parpadeantes optimizado
//     const createFlashNumber = (numberTxt) => {
//         if (!flashContainerRef.current) return;
//         const el = document.createElement('div');
//         el.className = 'flash-number';
//         el.innerText = numberTxt;
//         el.style.top = `${Math.random() * 100}%`;
//         el.style.left = `${Math.random() * 100}%`;
        
//         const size = Math.random() * 60 + 5;
//         el.style.fontSize = `${size}rem`;
//         if (size > 30) {
//             el.style.opacity = '0.3';
//             el.style.zIndex = '1';
//         } else {
//             el.style.zIndex = '6';
//         }

//         flashContainerRef.current.appendChild(el);
//         setTimeout(() => el.remove(), 500);
//     };

//     // --- VARIABLES CSS DINÁMICAS ---
//     const rootStyles = {
//         '--kit-color': lineup.kitColor,
//         '--accent-color': '#fbbf24' // Puedes agregar lógica para calcular el brillo aquí si lo deseas
//     };

//     return (
//         <div className="lineup-wrapper" style={rootStyles}>
            
//             {/* TÍTULO HEADER */}
//             <header className="lineup-header">
//                 <h1>{lineup.teamName}</h1>
//             </header>

//             {/* CANCHA EN 3D */}
//             <main className="lineup-main">
//                 <div className="pitch-container">
//                     <div className="pitch">
//                         <div className="center-line"></div>
//                         <div className="center-circle"></div>
//                         <div className="penalty-area penalty-left"></div>
//                         <div className="penalty-area penalty-right"></div>
//                         <div className="corner top-left"></div>
//                         <div className="corner top-right"></div>
//                         <div className="corner bottom-left"></div>
//                         <div className="corner bottom-right"></div>

//                         {/* RENDERIZADO DE JUGADORES EN LA CANCHA */}
//                         <div className="players-container">
//                             {lineup.players.map(p => (
//                                 <div 
//                                     key={p.playerId} 
//                                     className="player-card" 
//                                     style={{ left: `${p.positionX}%`, top: `${p.positionY}%` }}
//                                 >
//                                     <div className="kit-circle">
//                                         {p.dorsal}
//                                         {p.isCaptain && <div className="captain-badge">C</div>}
//                                     </div>
//                                     <div className="player-info">
//                                         <div className="player-name">{p.name}</div>
//                                     </div>
//                                 </div>
//                             ))}
//                         </div>
//                     </div>
//                 </div>

//                 {/* TARJETA DEL DIRECTOR TÉCNICO */}
//                 <div className="dt-card left">
//                     <div className="kit-circle dt-kit">DT</div>
//                     <div className="player-info">
//                         <div className="player-name">{lineup.managerName}</div>
//                     </div>
//                 </div>
//             </main>

//             {/* =========================================================
//                 OVERLAY DE PRESENTACIÓN "EUPHORIA"
//             ========================================================= */}
//             <div className={`presentation-overlay ${presentation.isActive ? 'active' : ''}`}>
//                 <img src="/img/overlays/lineup/logo.png" onError={(e) => e.target.style.display='none'} className="pres-logo" alt="Logo" />
                
//                 <div className="pres-layer pres-bg-base"></div>
//                 <div className={`pres-layer pres-bg-storm ${presentation.step >= 4 ? 'anim-bg-storm' : ''}`}></div>
//                 <div ref={flashContainerRef} className="pres-random-numbers"></div>

//                 <div className={`pres-container ${presentation.step === 3 ? 'anim-euphoria-shake' : ''}`}>
                    
//                     {/* ZONA DE FOTO */}
//                     <div className="pres-showcase-wrapper">
//                         <div className={`pres-photo-container ${presentation.step >= 3 ? 'anim-pro-card-reveal' : ''}`}>
//                             {presentation.player && (
//                                 <img 
//                                     src={`/img/overlays/lineup/players/${presentation.player?.isManager ? 'DT' : presentation.player?.dorsal}.png`} 
//                                     className={`pres-photo-img ${presentation.step >= 3 ? 'anim-pro-photo-zoom' : ''} ${presentation.step >= 4 ? 'anim-photo-alive' : ''}`} 
//                                     onError={(e) => {
//                                         e.target.onerror = null; // IMPORTANTE: Esto rompe el bucle
//                                         e.target.src = '/img/overlays/lineup/default.png';
//                                     }}
//                                     alt="Player" 
//                                 />
//                             )}
//                             {presentation.step >= 3 && <div className="pres-flare anim-pro-flare"></div>}
                            
//                             {/* DORSAL EN ESQUINA DE LA FOTO */}
//                             {presentation.step >= 3 && (
//                                 <div className="pres-card-number">
//                                     {presentation.player?.isManager ? 'DT' : presentation.player?.dorsal}
//                                 </div>
//                             )}
//                         </div>
//                     </div>

//                     {/* ZONA DE TEXTOS */}
//                     <div className={`pres-text-container ${presentation.step >= 2 ? 'anim-text-breathe' : ''}`}>
//                         <div className={`pres-firstname 
//                             ${presentation.step === 2 ? 'anim-glitch-slam anim-spread-first' : ''}
//                             ${presentation.step >= 4 ? 'pres-name-settled anim-electric-sustain' : ''}`}
//                         >
//                             {presentation.player?.firstName}
//                         </div>
                        
//                         <div className={`pres-lastname 
//                             ${presentation.step === 3 ? 'anim-glitch-slam anim-spread-last' : ''}
//                             ${presentation.step >= 4 ? 'pres-name-settled anim-electric-sustain' : ''}`}
//                         >
//                             {presentation.player?.lastName}
//                         </div>
//                     </div>

//                 </div>
//             </div>
//         </div>
//     );
// };

// export { Lineup };